import { render, staticRenderFns } from "./Lokasi.vue?vue&type=template&id=5c958ae4&scoped=true"
import script from "./Lokasi.vue?vue&type=script&lang=js"
export * from "./Lokasi.vue?vue&type=script&lang=js"
import style0 from "./Lokasi.vue?vue&type=style&index=0&id=5c958ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c958ae4",
  null
  
)

export default component.exports